<template>
  <div class="voteByBallot">
    <div class="index-header">
      <span class="title">
        <i class="el-icon-caret-right"></i>投票表决
      </span>
      <span class="other more" @click="jumpMore">
        更多
        <i class="el-icon-d-arrow-right"></i>
      </span>
    </div>
    <div class="voteByBallot-main">
      <el-radio-group v-model="Position" style="margin-bottom: 30px;" @change="getData()">
        <el-radio-button label="running">进行中</el-radio-button>
        <el-radio-button label="already">已完成</el-radio-button>
      </el-radio-group>
      <el-table
        :data="tableData"
        stripe
        :show-header="false"
        style="margin-top: 15px;"
        @row-dblclick="handleCheck"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="VoteTitle" :show-overflow-tooltip="true"></el-table-column>
        <el-table-column prop="BeginTime" width="180"></el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import { VoteQueryPara } from '@/models/queryparams/VoteQueryPara';
import { VoteControllerSvr } from '@/service/VoteControllerSvr';
import { mapState } from 'vuex';
export default {
  components: {},
  props: {},
  data() {
    return {
      Position: 'running',
      tableData: [],
      isDisable: true
    };
  },
  computed: {
    mainTitle: () => {
      return commonTitle;
    },
    ...mapState(['token'])
  },
  created() {
    this.VoteControllerSvr = new VoteControllerSvr();
    this.VoteQueryPara = new VoteQueryPara();
  },
  mounted() {
    this.getData('running');
  },
  methods: {
    jumpMore() {
      this.$router.push('/voteList');
    },
    getData() {
      if (this.Position === 'running') {
        this.VoteQueryPara.setParamByVoteState_Enum([3, 4]);
      } else {
        this.VoteQueryPara.setParamByVoteState_Enum([5]);
      }
      this.VoteControllerSvr.GetVoteList(
        this.token,
        this.VoteQueryPara,
        true,
        0,
        4,
        false
      ).then(res => {
        this.tableData = res._Items;
        for (const iterator of this.tableData) {
          iterator.BeginTime = iterator.BeginTime.split('T')[0];
        }
      });
    },
    // 双击查看
    handleCheck(row) {
      this.$router.push({
        path: 'voteDetail',
        query: { bisKey: row.KeyId, workId: row.WorkId }
      });
    }
  }
};
</script>
<style lang="scss">
@import './css/common.scss';
.voteByBallot {
  background-color: #fff;
  .voteByBallot-main {
    text-align: center;
    height: 210px;
    .el-table {
      padding: 0 20px 20px 20px;
    }
    .el-radio-group {
      margin-top: 15px;
      margin-bottom: 0 !important;
      .el-radio-button {
        .el-radio-button__inner {
          padding: 6px 20px;
        }
      }
    }
  }
}
</style>